export default __webpack_public_path__ + "static/media/righteye.40d2aed1.svg";